@if (shouldShowInformation) {
    <div class="ms-progress-bar-information">
        <span class="ms-progress-bar-information-text">{{ informationText }}</span>
        @if (shouldShowPercentage) {
            <span #percentage class="ms-progress-bar-information-value"></span>
        }
    </div>
}
<div class="ms-progress-bar-background-bar"><div #progress class="ms-progress-bar-indicator"></div></div>
